import styled from 'styled-components';

export const AppSwitcherWrapper = styled.div`
  height: 100%;

  .MuiPaper-root {
    background-color: ${({ theme }) => theme.appSwitcherBackgroundColor};

    .MuiTypography-root {
      color: ${({ theme }) => theme.appSwitcherColor};
    }

    .MuiButtonBase-root {
      color: ${({ theme }) => theme.appSwitcherButtonColor};

      svg g,
      svg path {
        fill: ${({ theme }) => theme.appSwitcherIconFill};
      }

      &.Mui-selected {
        color: ${({ theme }) => theme.appSwitcherButtonSelectedColor};
      }
    }

    .MuiMenuItem-root {
      &.Mui-selected {
        background-color: ${({ theme }) => theme.appSwitcherItemSelectedBackgroundColor};
      }

      &:hover {
        background-color: ${({ theme }) => theme.appSwitcherItemHover};
      }
    }
  }
`;
